import { createStyles, makeStyles, Theme } from "@material-ui/core";
const styles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			margin: 0,
		},
		addGroupDetail: {
			textAlign: "right",
			marginTop: "5px",
		},
		addGroupDetailBtn: {
			minWidth: "45px",
			padding: "6px",
		},
		groupNameTitle: {
			width: "70%",
			marginTop: "10px !important",
			marginBottom: "10px !important",
		},
		fileUploadBtn: {
			maxWidth: "40px",
			minWidth: "40px",
			padding: "6px !important",
			marginRight: "5px",
			marginTop: "20px",
		},
		fileInput: {
			display: "none",
		},
		excelTemplateUrlText: {
			display: "block",
			fontSize: "small",
			paddingTop: "10px",
		},
		removeRowContainer: {
			marginTop: "20px",
			position: "relative",
			textAlign: "right",
		},
		removeRowButton: {
			minWidth: "40px",
			maxWidth: "40px",
			padding: "6px",
			cursor: "pointer",
			right: "0px",
		},
		tableGrid: {
			padding: theme.spacing(1),
			margin: "auto",
			backgroundColor: "#eeeeee",
			maxWidth: "100%",
			minWidth: 300,
			marginTop: "20px",
			maxHeight: 600,
			overflow: "auto",
		},
		tableCell: {
			padding: "10px 10px",
		},
		fileName: {
			position: "absolute",
			marginTop: "25px",
			paddingLeft: "6px",
			paddingTop: "3px",
		},
		groupDivider: {
			border: "1px solid rgba(0, 0, 0, 0.12)",
			borderRadius: "3px",
			margin: "10px 0px",
			padding: "10px",
		},
		errorMessage: {
			textAlign: "center",
			color: "rgb(97, 26, 21)",
			padding: "5px",
			backgroundColor: "rgb(253, 236, 234)",
			maxWidth: "300px",
			minWidth: "200px",
			marginTop: "10px",
		},
		fileError: {
			marginTop: "12px",
		},
		columnSelect: {
			maxWidth: "367px",
			minWidth: "50px",
		},
		headerCheckBox: {
			marginTop: "20px",
		},
		tableConfiguration: {
			marginTop: "10px",
		},
		highlight: {
			backgroundColor: "#a5d6a7",
			border: "1px solid #a5d6a7",
		},
		warningMessage: {
			textAlign: "left",
			color: "#fff",
			padding: "10px",
			backgroundColor: "#ff9800",
			marginTop: "10px",
			"& a": {
				color: "#fff !important",
			},
		},
	})
);
export default styles;
